import { AnalysisAdditionalInfo } from "../../../../lib/enums";

export const getIsDecisiveReson = (
  reason: number,
  lowerLimit: number,
  upperLimit: number
) => {
  if (reason > upperLimit) return false;
  return !(reason < lowerLimit);
};

export const getIsNotConfigured = (status?: string) =>
  status === AnalysisAdditionalInfo.NOT_CONFIGURED;
